<mat-icon (click)="onIconClick($event)">
    {{iconName}}
</mat-icon>
